import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import './AppLayout.css';

const AppLayout: React.FC = () => {
  const [translations, setTranslations] = useState<Record<string, string>>({});

  return (
    <div className="app-layout-root">
      <div className="app-layout-wrapper">
        <Header translations={translations} />
        <div className="app-layout-container">
          <Outlet context={{ translations }} />
        </div>
      </div>
      <Footer onTranslationsLoaded={setTranslations} />
    </div>
  );
};

export default AppLayout;
